export enum EventOrderBy {
  Newest = 1,
  Popular,
  DateDescending,
  DateAscending,
}
